export default __webpack_public_path__ + "assets/fast-system.a443e403.svg";